<template>
    <div>
        <div class="home">
            <NavBar type="home"/>
            <div class="content">
                <div class="banner">
                    <div class="banner_info">
                        <div class="banner_title" >
                            <div class="title">云晰科技</div>
                            <div class="last_title">AI业绩增长解决方案领导者</div>
                        </div>
                    </div>
                </div>

                <div class="info flex_column">
                    <div class="title wow slideInUp">
                        <div class="first_title">产品手册</div>
                        <div class="last_title">一站式数字化业绩增长解决方案</div>
                    </div>

                    <div class="product_list_con flex">
                        <div class="product_item wow slideInUp" v-for="(item, index) in product" :key="index" @click="skip(item.path)">
                            <div class="icon">
                                <img :src="item.icon"/>
                            </div>
                            <div class="title">{{item.title}}</div>
                            <div class="sub_title">
                                <div>{{item.subtitle1}}</div>
                                <div>{{item.subtitle2}}</div>
                                <div>{{item.subtitle3}}</div>
                            </div>
                            <div class="next">
                                查看更多
                                <img src="https://resource.51beauty.com.cn/ca33ce9b-c56c-4584-be1c-067f682085e3?imageslim" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="foundation-wrap wow">
                    <div class="title">行业化解决方案</div>
                    <div class="subtitle">
                        <div>为您量身定制整体解决方案，助力业绩增长</div>
                        <div>支持本地化部署和系统打通，实现数据安全和业务闭环</div>
                    </div>
                </div>

                <div class="doctor">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="doctor_content wow slideInUp">
                                    <div class="doctor_introduce">云晰提供了一个专业的AI智能体解决方案，为我们搭建起属于自己的数字化系统。刚开始我们做了一场私域直播的活动，直播一小时内带来330单在线下单，5天内为我们带来了16000次的访问量。我坚信这样的AI智能体正在解决客户获客之道。</div>
                                    <div class="doctor_info">
                                        <div>
                                            <img src="https://resource.51beauty.com.cn/4e77c997-fe44-4afa-b5c7-2ac4452724e3?imageslim" alt="">
                                        </div>
                                        <div>
                                            <div>某世界500强</div>
                                            <div>中国区总经理</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="doctor_content wow slideInUp">
                                    <div class="doctor_introduce">使用云晰AI智能体解决方案，我将公众号和小程序交给AI进行管理。随着时间推移，我们的获客成本还将进一步降低，同时我们的员工还能更有效率地及时跟单、邀约成交。</div>
                                    <div class="doctor_info">
                                        <div>
                                            <img src="https://resource.51beauty.com.cn/8a00cc9a-833e-44d3-a01e-859cc17c7e2e?imageslim" alt="">
                                        </div>
                                        <div>
                                            <div>某上市公司</div>
                                            <div>业务高管</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="doctor_content wow slideInUp">
                                    <div class="doctor_introduce">我们使用云晰AI智能体解决方案，咨询师的效率和积极性都在提升。还能够为员工提供丰富的智能素材和智能话术，帮助员工提升转化率，让员工业绩出现明显增长。我们会持续选择AI智能体解决方案。</div>
                                    <div class="doctor_info">
                                        <div>
                                            <img src="https://resource.51beauty.com.cn/9786b4b1-dc54-41cb-897d-9bb1318e96d0?imageslim" alt="">
                                        </div>
                                        <div>
                                            <div>某本地生活机构</div>
                                            <div>业务高管</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="quotes_left">
                            <img src="https://resource.51beauty.com.cn/b59bfb5c-fbcb-4011-9b71-4c8a7776333d?imageslim" alt="">
                        </div>
                        <div class="quotes_right">
                            <img src="https://resource.51beauty.com.cn/f2ae2c4b-67d0-41f9-96a6-39a8c7ffa6b5?imageslim" alt="">
                        </div>
                    </div>
                    <div class="swiper_paging">
                        <div :style="swiperCur==0?'background:#fff':''" @click="toSwiper('0')"></div>
                        <div :style="swiperCur==1?'background:#fff':''" @click="toSwiper('1')"></div>
                        <div :style="swiperCur==2?'background:#fff':''" @click="toSwiper('2')"></div>
                    </div>
                </div>

<!--                <div class="contact">-->
<!--                    <div class="con_l">-->
<!--                        <div class="con_label">联系方式</div>-->
<!--                        <div class="con_info con_info_1">市场邮箱：market@xitech.com.cn</div>-->
<!--                        <div class="con_info">公司地址：北京市朝阳区百子湾东朝时代西区109室</div>-->
<!--                    </div>-->
<!--                    <div class="con_r">-->
<!--                        <div class="code_box">-->
<!--                            <img src="https://resource.51beauty.com.cn/9ffef6d3-eed5-4727-baa9-5d018bb12849?imageslim" />-->
<!--                            <div class="code_name">医美行业</div>-->
<!--                        </div>-->
<!--                        <div class="code_box">-->
<!--                            <img src="https://resource.51beauty.com.cn/e8e6d67a-9e72-4d83-a731-94614bf18e5f?imageslim" />-->
<!--                            <div class="code_name">口腔行业</div>-->
<!--                        </div>-->
<!--                        <div class="code_more">-->
<!--                            <div class="prompt">更多详情</div>-->
<!--                            <div class="prompt">请添加云晰营销官企业微信</div>-->
<!--                            <div class="prompt">随时为您答疑解惑</div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
<!--            <div class="call" @click="openAppoint">-->
<!--                <img src="../assets/fuceng.png" alt="">-->
<!--            </div>-->
            <Bottom @openWord="openWord"/>
            <appointment :visibleDialog="appointmentVisible" @closeAppoint="closeAppoint" />
            <word :wordDialog="wordVisible" @closeWord="closeWord" />
            <Contact />
        </div>
    </div>
</template>
<script>
import NavBar from '@/components/navBar.vue'
import Bottom from '@/components/bottom.vue'
import Appointment from '@/components/appointment.vue'
import Word from '@/components/word.vue'
import Contact from '@/components/contact.vue'
import { WOW } from 'wowjs'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
var swiper = {}
export default {
    name: 'home',
    components: {
        NavBar,
        Bottom,
        Appointment,
        Word,
        Contact
    },
    data() {
        return {
            status: [],
            type: [],
            product: [
              {
                'icon': 'https://resource.51beauty.com.cn/qianduan_forever/ce62dc309f5a47ff895b99a4da1fec2d/live.png', // 默认icon
                'title': '私域直播', // 主标题
                'path': '/live',
                'subtitle1': '提供完整的直播解决方案', // 副标题1
                'subtitle2': '和代运营服务', // 副标题2
              },
              {
                  'icon': 'https://resource.51beauty.com.cn/qianduan_forever/b84c1288de8a4d65a40e7d818ddbe616/community.png', // 默认icon
                  'title': '社群运营', // 主标题
                  'path': '/community',
                  'subtitle1': '基于企微/社群的用户运营与行为溯源', // 副标题1
                  'subtitle2': '实现裂变增长', // 副标题2
              },
              {
                'icon': 'https://resource.51beauty.com.cn/qianduan_forever/51f28d2d7eee4ecea1d979e65c19f796/aI-agent.png', // 默认icon
                'title': 'AI智能体', // 主标题
                'path': '/ai',
                'subtitle1': '实现智能话术推荐、用户', // 副标题1
                'subtitle2': '画像分析、商品千人千面', // 副标题2
              },
            {
                'icon': 'https://resource.51beauty.com.cn/qianduan_forever/2e97867e4cf348bfaab123094f882ac9/vip.png', // 默认icon
                'title': '会员管理', // 主标题
                'path': '/member',
                'subtitle1': '轻松构建会员标签体系', // 副标题1
                'subtitle2': '构建科学会员成长体系', // 副标题2
              },
              {
                  'icon': 'https://resource.51beauty.com.cn/qianduan_forever/066e2c43b4294ad1b7fbfb418e961b76/public-live.png', // 默认icon
                  'title': '公域直播', // 主标题
                  'path': '/publicLive',
                  'subtitle1': '提供抖音、视频号等多个', // 副标题1
                  'subtitle2': '平台的一体化代运营服务', // 副标题2
              },
              {
                'icon': 'https://resource.51beauty.com.cn/qianduan_forever/806ca4a645c147318716cd9a339dcff5/traffic.png', // 默认icon
                'title': '流量获客', // 主标题
                'path': '/advertising',
                'subtitle1': '对接主流广告投放平台', // 副标题1
                'subtitle2': '决策引擎实现智能投放', // 副标题2
              },
            ],
            tabList: [
              { name: '口腔',value: 0 },
              { name: '眼科',value: 2 },
              { name: '中医',value: 3 },
              { name: '医美',value: 1 },
            ], // 行业类型
            curTab: 0,  // 当前切换的行业类型
            tabImgs:[
                'https://resource.51beauty.com.cn/68a5e6db-c4ce-4509-abeb-d38816dd0a68?imageslim', // 医美
                'https://resource.51beauty.com.cn/b368cd1b-2cf7-4748-b94d-f733d8669b84?imageslim', // 口腔
                'https://resource.51beauty.com.cn/ec0548db-2b18-4ce3-9f52-499bc6384717?imageslim', // 眼科
                'https://resource.51beauty.com.cn/e676ae51-32e6-483a-a93e-a85bfc3aa438?imageslim' // 植发
            ], // 当前行业对应的行业图
            appointmentVisible: false, // 预约弹层是否显示
            wordVisible: false,
            cur: 0, //默认选中第一个tab
            plans: [
                {
                    img: "https://resource.51beauty.com.cn/8c394f63-1ced-4f32-b44b-482816a617d0?imageslim", // 主图片
                    title: "口腔解决方案", // // 主标题
                    subtitle: "为口腔医疗提供全流程解决方案", // 标题
                    path:'/oral',
                    con1:'-任务提醒',
                    con2:'-话术赋能',
                    con3:'-精准营销',
                    con4:'-建档跟进',
                },
                {
                    img: "https://resource.51beauty.com.cn/5e4f4862-8dbe-4ad7-af47-b6aa288051cb?imageslim", // 主图片
                    title: "医美解决方案", // // 主标题
                    subtitle: "为医美行业提供全流程解决方案", // 标题
                    path:'/beauty',
                    con1:'-公私域一体化',
                    con2:'-客户精准画像',
                    con3:'-聊天内容存档',
                    con4:'-客户资源保全',
                },
                {
                    img: "https://resource.51beauty.com.cn/bd9edb96-31d9-47f9-a899-182e97f29163?imageslim",
                    title: "眼科解决方案", // // 主标题
                    subtitle: "为眼科医疗提供全流程解决方案", // 标题
                    path:'/eye',
                    con1:'-高效管理线索',
                    con2:'-快速获客分享',
                    con3:'-掌握客户意向',
                    con4:'-协同服务客户',
                },
                {
                    img: "https://resource.51beauty.com.cn/fe722a1f-3b03-42f9-900e-9bf67923c0fc?imagesli",
                    title: "中医解决方案", // // 主标题
                    subtitle: "为中医行业提供全流程解决方案", // 标题
                    path:'/hair',
                    con1:'-全线索管理',
                    con2:'-流程标准化',
                    con3:'-高粘性运营',
                    con4:'-个性化定制',
                }
            ],
            logoList:[
                'https://resource.51beauty.com.cn/36723e1a-191c-48b2-906c-9025907d3f0d?imageslim',
                'https://resource.51beauty.com.cn/d9e1d62a-4bfc-4cc9-bb0d-dd40908fc6e9?imageslim',
                'https://resource.51beauty.com.cn/f291f046-b7e8-47ce-9631-c6d9d862dc54?imageslim',
                'https://resource.51beauty.com.cn/4b0282b8-0228-44af-b894-1af18a6d70f9?imageslim',
                'https://resource.51beauty.com.cn/39109535-2033-47ec-b608-6590dc967a13?imageslim',
                'https://resource.51beauty.com.cn/268c377e-7d4f-4188-8a65-f049967bd073?imageslim',
                'https://resource.51beauty.com.cn/e539333c-2f51-467c-86c1-d84d9943fd17?imageslim',
                'https://resource.51beauty.com.cn/75ce1603-7144-4210-98af-f5ac19ddc316?imageslim',
                'https://resource.51beauty.com.cn/34c6927b-652a-4a4a-b3a3-29582e186b88?imageslim',
                'https://resource.51beauty.com.cn/0ddf30fd-af90-40de-a9fb-0a67051a636d?imageslim',
                'https://resource.51beauty.com.cn/3244eaa8-580d-4d3f-befc-3b8475bc4962?imageslim',
                'https://resource.51beauty.com.cn/ac41529f-dc08-422e-bf84-1071bf53eb09?imageslim',
                'https://resource.51beauty.com.cn/e4e20cb4-b8f0-45b8-8a50-53caa561c842?imageslim',
                'https://resource.51beauty.com.cn/5743e0f9-76a7-40b1-84ec-8b3a709a7ab0?imageslim',
                'https://resource.51beauty.com.cn/53112e40-7b8f-4b6e-8df7-4f0987db38ff?imageslim',
                'https://resource.51beauty.com.cn/7d6fc345-c99e-43fb-8407-387458d9d4d6?imageslim',
                'https://resource.51beauty.com.cn/638a0387-b3be-47cc-a464-376b3f83a2d8?imageslim',
                'https://resource.51beauty.com.cn/2182a444-f004-4b1a-b2da-c67536c24f73?imageslim',
                'https://resource.51beauty.com.cn/7b7d656b-b73f-47d6-9ab5-40eaea172dcb?imageslim',
                'https://resource.51beauty.com.cn/4fff0d2f-3c6a-4442-bdb3-e178bbfbf1fa?imageslim',
                'https://resource.51beauty.com.cn/5cd47cad-05cf-4032-abf9-8ef695225f57?imageslim',
                'https://resource.51beauty.com.cn/5c6b41e7-d6e6-48c7-b573-a58ae35d0cd1?imageslim',
                'https://resource.51beauty.com.cn/800e782d-d43d-4b9a-8a96-15b82dfdcec6?imageslim',
                'https://resource.51beauty.com.cn/33c4cda8-da26-4f4f-8965-54c7ac2ffa2c?imageslim',
                'https://resource.51beauty.com.cn/cfbc0da0-cd11-4f33-9397-149fad38f37f?imageslim',
                'https://resource.51beauty.com.cn/26e8bc6f-6741-4262-a461-b1616e16a118?imageslim',
                'https://resource.51beauty.com.cn/e66e02aa-4c81-4241-b3a1-8e335261ca2e?imageslim',
                'https://resource.51beauty.com.cn/52f202cd-7c78-42e6-a858-8d22f391d20e?imageslim',
                'https://resource.51beauty.com.cn/c4b89925-cf1f-45d3-8d71-401ae905d770?imageslim',
                'https://resource.51beauty.com.cn/27c9c791-73d9-4231-975d-ec5beb27c7ef?imageslim',
                'https://resource.51beauty.com.cn/eff3d968-dbd2-4deb-bcdd-5e5c96c38e80?imageslim',
                'https://resource.51beauty.com.cn/72db069b-bb74-4efb-aa3a-9d1a7f26bcbd?imageslim',
                'https://resource.51beauty.com.cn/b2ebc223-0a5c-4505-8b31-2e4215baa1e5?imageslim',
                'https://resource.51beauty.com.cn/11bf663c-a8f9-46ca-9037-8bb1f6c9f0c1?imageslim',
                'https://resource.51beauty.com.cn/bd88cabb-0a8b-4e4d-9d10-142a69e5babb?imageslim',
                'https://resource.51beauty.com.cn/0c1e7a5f-11f8-4831-b530-d839a19619a3?imageslim'
            ],
            swiperCur:0
        }
    },
    mounted() {
        // this.getData()
        new WOW().init()
        let that = this
        swiper = new Swiper('.swiper-container', {
            autoplay:5000,
            speed:1000,
            onSlideChangeStart: function(swiper){
                that.swiperCur = swiper.activeIndex
            }

        })
    },
    methods: {
        skip(path){
            this.$router.push(path)
        },
        toSwiper(index){
            swiper.solidTo(index)
        },
        getData(){
            this.$api.post('/bobo-admin/interface/order/count', {}, response => {
                const data = response.data.status
                const type = response.data.type
                data.map(item=>{
                    item.percent = Number(item.percent)
                })
                type.map(item=>{
                    item.percent = Number(item.percent)
                })
                this.status = data
                this.type = type
                this.getStatus(data)
                this.getType(type)
            });
        },
        setTab (value) {
            if (value !== this.curTab) {
                this.curTab = value
            }
        },
        // 关闭预约弹层
        closeAppoint (e) {
            this.appointmentVisible = e
        },
        closeWord (e) {
            this.wordVisible = e
        },
        openWord () {
            this.wordVisible = true
        },
        // 打开预约弹层
        openAppoint () {
            this.appointmentVisible = true
        },
        // 查看详情-跳转至产品页面
        goPage () {
            this.$router.push({
                path: "/my"
            })
        }
    }

}

</script>
<style scoped lang="less">
    .home {
        position: relative;
        padding-top: 0px;
        .swiper_paging{
            width: 23px;
            height: 1px;
            background: rgba(255,255,255,.2);
            border-radius: 1px;
            margin: 0 auto;
            margin-top: 10px;
            display: flex;
            >div{
                width: 8px;
                transition: .5s;
                border-radius: 1px;
            }
        }
        .segmentation{
            width: 100%;
            height:.3px;
            background: #000000;
            opacity: 0.1;
        }
        .call{
            position: fixed;
            bottom: 50px;
            left: 335px;
            img{
                width: 30px;
                height: 30px;
            }
        }
        .flex_column{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }
        .flex{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .product_list_con{
          margin-top: 16px;
          width: 250px;
          flex-wrap: wrap;
          justify-content: space-between;
            .product_item{
                width: 78px;
                height: 83px;
                text-align: center;
                transition: .3s ease-in-out;
                position: relative;
                overflow: hidden;
                cursor: pointer;
                .icon{
                    img{
                        width: 21px;
                        height: 21px;
                        display: block;
                        margin: 0 auto;
                        margin-top: 3px;
                    }
                }
                .title{
                    color: #2C68FF;
                    font-size: 5px;
                    margin-top: 6px;
                    font-weight: bold;
                    margin-bottom: 4px;
                }
                .sub_title{
                    color: #273755;
                    font-size: 3px;
                    opacity: .5;
                    div{
                        margin-bottom: 1px;
                    }
                }
                .next{
                    position: absolute;
                    left: 34px;
                    bottom: -10px;
                    transition: .6s ease-out;
                    opacity: 0;
                    display: flex;
                    align-items: center;
                    font-size: 3px;
                    img{
                        width: 6px;
                        height: 6px;
                        margin: 0 auto;
                        display: block;
                    }
                }

            }
            .product_item:hover{
                box-shadow: 0px 2px 4px 0px rgba(55,99,170,0.1);
                border-radius: 2px;
            }
            .product_item:hover .next{
                bottom: 4px;
                /*left: 32px;*/
                opacity: 1;
                color: #2C68FF;
            }
        }
        .tab_bolck{
            background: #FAFBFD;
            margin-top: 20px;
        }
        .content{
            display: flex;
            align-items: center;
            flex-direction: column;
            .banner{
                width: 375px;
                height: 145px;
                background: url('https://resource.51beauty.com.cn/9d0c339f-7000-4596-b5b7-4c85fd83e4f2?imageslim') no-repeat;
                background-size: cover;
                .banner_info{
                    padding-top: 18px;
                    padding-left: 70px;
                }
                .banner_title{
                    margin-top: 37px;
                }
                .title{
                    font-size: 23px;
                    font-weight: 500;
                    color: #2C68FF;
                    margin-top: -2px;
                }
                .last_title{
                    height: 4px;
                    font-size: 8px;
                    font-weight: 400;
                    color: #273755;
                    margin-top: 4px;
                    letter-spacing: 2px;
                }
            }
            .info{
                box-sizing: border-box;
                width: 375px;
                .title{
                    text-align: center;
                }
                .first_title{
                    font-size: 7.5px;
                    font-weight: bold;
                    color: #000;
                    margin-top: 29px;
                    span{
                        color: #196FF1;
                    }
                }
                .img_title{
                    font-size: 7px;
                    color: #fff;
                    font-weight: 500;
                    margin-top: 22px;
                }
                .last_title{
                    font-size: 4px;
                    font-weight: 400;
                    color: #273755;
                    margin-top: 4px;
                }


                .tab_box{
                    margin-top: 12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .tab_item{
                        width: 39px;
                      
                        position: relative;
                        border-left: 0;
                        font-size: 5px;
                        color: #333333;
                        transition: all 0.35s;
                        cursor: pointer;
                        font-weight: bold;
                        text-align: center;
                    }
                    .line{
                        width: 12px;
                        height: 1px;
                        background: #2C68FF;
                        margin: 0 auto;
                        margin-top: 4px;
                        transition:all .3s ease-in-out;
                    }
                    .tab_item:hover{
                        color: #2278F0;
                    }
                    .tab_item.tab_active{
                        color: #2C68FF;
                    }
                }
                .tab_img{
                    margin-top: 14px;
                    width: 235px;
                    img{
                        width: 235px;
                        height: auto;
                        vertical-align: top;
                    }
                }
            }

            .contact{
                width: 375px;
                padding: 12px 70px 10px;
                background: #2278F0;
                margin-top: 24px;
                color: #fff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .con_l{
                    .con_label{
                        font-size: 6px;
                        padding-bottom: 8px;
                    }
                    .con_info{
                        font-size: 4px;
                        line-height: 7px;
                    }
                    .con_info.con_info_1 {
                        padding-bottom: 3px;
                    }
                }
                .con_r{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .code_box{
                        width: 29px;
                        margin-right: 4px;
                        background: rgba(255, 255, 255, 0.1);
                        img{
                            width: 29px;
                            height: auto;
                            vertical-align: top;
                        }
                        .code_name{
                            font-size: 4px;
                            text-align: center;
                            padding: 2px 0;
                        }
                    }
                    .code_more{
                        .prompt{
                            font-size: 4px;
                            line-height: 6px;
                        }
                    }
                }
            }
        }
        .tab_content{
            display: flex;
            margin-top: 11px;
            padding-bottom: 30px;
            .tab_content_left{
                img{
                    width: 156px;
                    display: block;
                }
            }
            .tab_content_right{
                width: 76px;
                padding-left: 20px;
                font-size: 4px;
                color: #273755;
                .tab_content_right_title{
                    margin-top: 7px;
                    font-size: 6px;
                    font-weight: bold;
                    color: #000;
                }
                .tab_content_right_subtitle{
                    margin: 2px 0 8px 0;
                    color: #273755;
                    opacity: .5;
                }
                .tab_content_right_list{
                    margin-bottom: 4px;
                }
                .tab_content_right_btn{
                    width: 33px;
                    height: 10px;
                    border-radius: 1px;
                    border: .3px solid #98A3B7;
                    color: #98A3B7;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top:10px;
                    transition: .3s;
                    cursor: pointer;

                }
                .tab_content_right_btn:hover{
                    color: #fff;
                    border-color: #2C68FF !important;
                    background: #2C68FF !important;
                }
            }
        }
        .logo_content{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 300px;
            img{
                width: 43px;
                height: 18px;
                display: block;
                margin-top: 10px;
            }
        }
        .foundation-wrap {
            width: 375px;
            height: 125px;
            background: url('https://resource.51beauty.com.cn/qianduan_forever/ccb092f192a04995a1f1568463557b9c/foundation.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 4px;
            padding-left: 69px;
            margin-top: 20px;
            .title {
                font-weight: 500;
                font-size: 11px;
                color: #2C69FF;
            }
            .subtitle {
                font-weight: 400;
                font-size: 4px;
                color: #273755;
            }
        }
        .doctor{
            height: 95px;
            width: 375px;
            background: #2C68FF;
            color: #fff;
            .swiper-container{
                width: 186px;
                margin: 0 auto;
                position: relative;
                margin-top: 20px;
                .quotes_left{
                    position: absolute;
                    left: 0;
                    top: 0;
                    img{
                        width: 8px;
                        height: 8px;
                        display: block;
                    }
                    z-index: 99;
                }
                .quotes_right{
                    position: absolute;
                    right: 0px;
                    bottom: 10px;
                    z-index: 99;
                    img{
                        width: 8px;
                        height: 8px;
                        display: block;
                    }
                }
            }
            .doctor_content{
                width: 186px;
                margin: 0 auto;
                /*margin-top: 8px;*/
                background: #2C68FF;
                .doctor_introduce{
                    padding-top: 12px;
                    width: 153px;
                    height: 33px;
                    margin: 0 auto;
                    font-size: 3px;
                    line-height: 5px;
                }
                .doctor_info{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 10px;
                    img{
                        width: 11px;
                        height: 11px;
                        display: block;
                        border-radius: 50%;
                    }
                    >div:nth-child(2){
                        font-size: 4px;
                        margin-left: 3px;
                        font-weight: bold;
                        >div:nth-child(2){
                            font-size: 3px;
                            font-weight: normal;
                        }
                    }
                }
            }
        }
    }
</style>
